module.exports = __webpack_public_path__ + "img/IconFlightDeck.5b98790d.png";